import { Component, ElementRef, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import * as Plotly from 'plotly.js';
declare global {
  interface Window {
    Plotly: typeof Plotly;
  }
}
@Component({
  selector: 'app-line-chart',
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.css']
})
export class LineChartComponent implements OnInit, OnChanges {
  @ViewChild("line", { static: true })
  private _line: ElementRef;
  @Input() lineData: any;
  @Input() index: any;
  constructor() { }

  ngOnInit(): void { } 

  ngOnChanges() {
    if (this.lineData.length)
      this._plotGraph();
  }

  private _plotGraph() {
    window.Plotly.newPlot(
      this._line.nativeElement, //viewchild element
      this.lineData, //data provided
      {
        margin: this.lineData[0].margin ? this.lineData[0].margin : '',
        height: this.lineData[0].height ? this.lineData[0].height : '',
        title: this.lineData[0].title, //Title of the graph
        hovermode: "closest",
        showlegend: this.lineData[0].legend ? this.lineData[0].legend : false,
        legend: { orientation: "h", y: -.1 },
        yaxis: {
          fixedrange: true,
          tickangle: -45,
          showgrid: this.lineData[0].showgrid,
          title: {
            text: this.lineData[0].yTitle,
            font: {
              family: 'Inter',
              color: '#1CA6AD'
            }
          },
        },
        yaxis2: this.lineData[0].yaxis2 ? {
          title: {
            text: this.lineData[1].yTitle,
            font: {
              family: 'Inter',
              color: '#FF718B'
            }
          },
          overlaying: 'y',
          side: 'right'
        } : {},
        xaxis: {
          // fixedrange: true,
          showgrid: this.lineData[0].showgrid,
          title: {
            text: this.lineData[0].xTitle,
          },
          tickmode: "array", // If "array", the placement of the ticks is set via `tickvals` and the tick text is `ticktext`.
          tickvals: this.lineData[0].x,
          ticktext: this.lineData[0].tickvals,
          tickfont: {
            family: 'Inter',
            size: 8,
            color: 'black'
          },
        },
        paper_bgcolor: this.lineData[0].barColor ? this.lineData[0].barColor : "#f6f6f6",
        plot_bgcolor: this.lineData[0].barColor ? this.lineData[0].barColor : "#f6f6f6",
        annotations: this.lineData[0].annotations,
        dragmode: false
      },
      { //this is where the configuration is defined
        responsive: true,
        displaylogo: false,
        scrollZoom: false,
        displayModeBar: false,
      });
    window.dispatchEvent(new Event('resize'));
  }
}
